import React from 'react';

const InvoiceBuilderContext = React.createContext('client_context');

export const InvoiceBuilderContextProvider = InvoiceBuilderContext.Provider;

export default InvoiceBuilderContext;
